import React from 'react';
import '../styles/page.css';


export class Page extends React.Component {
  constructor(props) {
    super(props);

    let hImg;
    let fImg;
    let hfClass;
    if( this.props.imageSet === undefined || this.props.imageSet === "1"){
      hImg = require("../assets/elements/page header scenery.svg");
      fImg = require("../assets/elements/page footer scenery.svg");
      hfClass = "scenery1";
    } else if( this.props.imageSet === "2") {
      hImg = require("../assets/elements/page header scenery 2.svg");
      fImg = require("../assets/elements/page footer scenery 2.svg");
      hfClass = "scenery2";
    } else if( this.props.imageSet === "3") {
      hImg = require("../assets/elements/page header scenery.svg");
      fImg = "";
      hfClass = "scenery1";
    }

    if( this.props.type === "endScore") {
      hImg = require("../assets/elements/page header scenery 3.svg");
      fImg = require("../assets/elements/page footer scenery.svg");
      hfClass = "scenery1";
    }


    this.state = {
      pageTitle: this.props.pageTitle || "Default",
      logo: require("../assets/elements/EnecoGroep logo.svg"),
      headerImg: hImg,
      footerImg: fImg,
      hfClass: hfClass,
    }
  }

  getDefault = () => {
    return (
      <div className="outer">
        <div className="page">
          <header>
            <div className="inner">
              <h1>{this.state.pageTitle}</h1>
            </div>
            <img className={"scenery " + this.state.hfClass} alt="scenery" src={this.state.headerImg} />
          </header>
          <div className="pageContent">
            <div className={"inner " + this.props.width}>
              {this.props.children}
            </div>
          </div>
          <footer>
            <img className="logo" alt="Eneco Group logo" src={this.state.logo} />
            {(this.state.footerImg === "" ? "" : <img className={"scenery " + this.state.hfClass} alt="scenery" src={this.state.footerImg} />)}
          </footer>
        </div>
      </div>
    )
  }

  getEndScreen = () => {
    return (
      <div className="outer">
        <div className="page">
          <header className="endScore">
            <div className="inner">
              <h1>{this.state.pageTitle}</h1>
            </div>
            <img className={"scenery " + this.state.hfClass} alt="scenery" src={this.state.headerImg} />
          </header>
          <div className="pageContent endScore">
            <div className={"inner superWide"}>
              {this.props.children}
            </div>
          </div>
          <footer>
            <img className="logo" alt="Eneco Group logo" src={this.state.logo} />
            {(this.state.footerImg === "" ? "" : <img className={"scenery " + this.state.hfClass} alt="scenery" src={this.state.footerImg} />)}
          </footer>
        </div>
      </div>
    )
  }

  render() {
    return (this.props.type === "endScore" ? this.getEndScreen() : this.getDefault());
  };
}



// WEBPACK FOOTER //
// ./src/pages/page.js